export default "__VITE_ASSET__PhcHYrYN__"